// if we ever need to disable ads for quizzes, turn this flag to true
const DISABLE_ADS_IN_QUIZZES = false;
function canDisplayAds() {
    if (DISABLE_ADS_IN_QUIZZES) {
        return false;
    }
    const context = window.SilverSurferSDK.getContext();
    // if ad block is detected, we cannot display anything
    if (context.features.adBlockDetected) {
        return false;
    }
    // do not display ads for logged-in user
    if (!(context === null || context === void 0 ? void 0 : context.user.anon)) {
        return false;
    }
    // we should be able to display ads
    return true;
}
export default canDisplayAds;
